import { FormControlLabel, InputAdornment, Radio, RadioGroup, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { Controller } from 'react-hook-form';

export function AppRadio({
  field = {},
  control,
  errors,
  readOnly,
  disabled,
  multiline,
  rows,
  size,
  getValues,
  setValue,
  title,
  label = [],
  onValueChange = () => { },
  emitEvent = () => { },
  ...rest
}) {
  const otherProps = {};
  let adornment = {};
  if (multiline || field.multiline) {
    otherProps['multiline'] = true;
    otherProps['rows'] = field.rows || rows || 2;
  }
  if (Boolean(_.get(errors, [field.id, 'message']))) {
    otherProps['helperText'] = _.get(errors, [field.id, 'message'], 'Error');
  }
  if (field.adornment) {
    if (field.adornment.position === 'end') {
      adornment['endAdornment'] = (
        <InputAdornment position="end">
          <field.adornment.icon fontSize={field.adornment.fontSize} color={field.adornment.color} />
        </InputAdornment>
      );
    }
  }



  /**
   * renders
   */
  return (
    <Controller
      name={field.id}
      defaultValue={field.defaultValue || ""}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <div style={{ display: 'flex' }}>
            <Typography style={{ paddingRight: 10, lineHeight: 2 }}>{title}</Typography>
            
            <RadioGroup
              style={{ display: 'flex', flexDirection: 'row' }}
              aria-label="position"
              name="type"
              onChange={(e) => {
                onChange(e.target.value)
                onValueChange({ id: field.id, value: e.target.value })
              }}
              // defaultValue={value}
 
            // onChange={(e) => handleType_change(e)}
            value={value}
            >
              {label.map((i, idx) => {
                return (
                  <FormControlLabel
                    key={idx}
                    value={i.id}
                    control={<Radio color="primary"
                      sx={{
                        '& .MuiSvgIcon-root': {
                          fontSize: 14,
                        },
                      }}

                    />}
                    label={i.label}
                  />
                )
              })}


            </RadioGroup>
          </div>

        );
      }}
    />
  );
}
